import { api } from "./api";
import type { ReportClient } from "./report";

export const reportClient: ReportClient = {
  createRun: (input) => api.createReportRun(input),
  updatePlan: (runId, input) => api.updateReportPlan(runId, input),
  getRun: (runId) => api.getReportRun(runId),
  startRun: (runId, input) => api.startReportRun(runId, input),
  listRuns: (params) => api.listReportRuns(params),
  deleteRun: (runId) => api.deleteReportRun(runId),
};
